module.exports = __webpack_public_path__ + "static/media/final_characters.f7cef1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/final_characters.png
// module id = 1110
// module chunks = 21